/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Directory_Submit_Enrich_Fast_Track_CtaInputs */

const en_directory_submit_enrich_fast_track_cta = /** @type {(inputs: Directory_Submit_Enrich_Fast_Track_CtaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fast Track — publish now · ${i?.price}`)
};

const zh_directory_submit_enrich_fast_track_cta = /** @type {(inputs: Directory_Submit_Enrich_Fast_Track_CtaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fast Track — 立即发布 · ${i?.price}`)
};

/**
* | output |
* | --- |
* | "Fast Track — publish now · {price}" |
*
* @param {Directory_Submit_Enrich_Fast_Track_CtaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_fast_track_cta = /** @type {((inputs: Directory_Submit_Enrich_Fast_Track_CtaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Fast_Track_CtaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_fast_track_cta(inputs)
	return zh_directory_submit_enrich_fast_track_cta(inputs)
});
export { directory_submit_enrich_fast_track_cta as "directory.submit.enrich.fast_track_cta" }